module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image4k.33833e26.jpg";